import { user } from '@/ui/auth/auth';

const curriedParseInt = (radix: number) => (value: string) => parseInt(value, radix);

export const parseInt10 = curriedParseInt(10);

export const toFixed = (number: number, fraction = 2) => Math.round(number) === number
  ? number
  : number.toFixed(fraction);

export const getDecimalPercentage = (percentage: number) => percentage / 100;

export const isNumberDefined = (value: number | null | undefined) => typeof value !== 'undefined' && value !== null;

export const clamp = (minValue: number, value: number, maxValue: number) => {
  return Math.max(minValue, Math.min(value, maxValue));
};

export const localeFormat = (value: number) => Intl.NumberFormat(user.value.locale).format(value);
